// extracted by mini-css-extract-plugin
export default {"header":"history_header__eR3zn","proposalsHeader":"history_proposalsHeader__RG+B7","radioButtons":"history_radioButtons__-hGhx"};